if (!customElements.get("scroll-store-message")) {
    customElements.define(
      "scroll-store-message",
      class ScrollStoreMessage extends HTMLElement {
        constructor(){
          super();
          this.marqueeDom = $(this).find('.marquee');
          this.initMarquee();
        }

        initMarquee(){
          const that = this;
          setTimeout(function(){
            $(that).find('.marquee').marquee({
              startVisible : true,
              duplicated : true,
              speed: 40,
              pauseOnHover: true,
              loop: -1,
              pauseSpeed: 0
            });
          },0)
        }
      }
    )
}